import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PickAdvertiserComponent } from './pick-advertiser.component';
import { PickAdvertiserResolve } from './pick-advertiser.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'pick-advertiser',
        component: PickAdvertiserComponent,
        resolve: {
          portal: PickAdvertiserResolve
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class PickAdvertiserRoutingModule {}
